<template>
    <el-select :value="selectedPart" class="select" filterable remote :remote-method="searchParts" :placeholder="$t('common.pleaseSelectPart')" :loading="loading" @change="partSelected" :disabled="disabled">
        <el-option v-for="item in parts" :key="item.id" :label="item.name" :value="item"></el-option>
    </el-select>
</template>

<script>
import api from "./api";
export default {
  name: "part-selector",

  props: {
    serviceCompanyId: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      selectedPart: undefined,
      parts: []
    };
  },
  methods: {
    searchParts(term) {
      var self = this;
      self.loading = true;
      api.getParts(term, this.serviceCompanyId).then(function(response) {
        self.loading = false;
        self.parts = response.data;
      });
    },
    partSelected(value) {
      if (value) {
        this.$emit("part-selected", Object.assign({}, value));
      }
    }
  }
};
</script>

<style scoped>
.select {
  width: 100%;
}

.select >>> .el-input__inner {
  padding-left: 30px;
}

.select:before {
  font-family: element-icons !important;
  content: "\E619";
  position: absolute;
  left: 10px;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/partselector/PartSelector.vue